import {useParams} from 'react-router-dom';

import {useProjectParams} from '../../pages/ProjectPage/useProjectParams';
import {getNwIdSearchString} from '../../state/workspaces/url';
import {useStatsigGateWorkspaceConsolidation} from '../../util/rampFeatureFlags';
import * as urls from '../../util/urls';

export function useRunDetailsTo(runName: string) {
  const {entityName, projectName} = useProjectParams();
  const {groupName, sweepName} = useParams<{
    groupName?: string;
    sweepName?: string;
  }>();

  const isWorkspaceConsolidationEnabled =
    useStatsigGateWorkspaceConsolidation();

  let baseProjectUrl: string;
  if (groupName && isWorkspaceConsolidationEnabled) {
    baseProjectUrl = urls.runGroup({entityName, projectName, name: groupName});
  } else if (sweepName && isWorkspaceConsolidationEnabled) {
    baseProjectUrl = urls.sweep({entityName, projectName, sweepName});
  } else {
    baseProjectUrl = urls.project({entityName, name: projectName});
  }

  const nwId = getNwIdSearchString();

  return (tab?: string) => ({
    pathname: `${baseProjectUrl}/runs/${runName}${tab ? `/${tab}` : ''}`,
    search: nwId,
  });
}
